import { Unidade, UnidadeConversao } from '../@types';

const convertUnidade = (unidade: Unidade): UnidadeConversao => ({
  id: unidade.id,
  abreviatura: unidade.abreviatura,
  descricao: unidade.descricao,
  descricaoPadrao: unidade.descricaoPadrao,
  taxa: unidade.unidadeConversao.taxa,
  taxaSementes: unidade.unidadeConversao.taxaSementes,
});

export default convertUnidade;
